class GEOIPHTMLElement extends HTMLElement {
    geoIpCacheTTL = 4 * 60 * 60 * 1000; // 4 hours
    geoIpCacheKey = 'visitor_country_cache';

    log (message, data = null) {
        if (!this.isDebug) return;
        const className = this.constructor.name;
        console.log(`[${className}] ${message}`, data || '');
    }

    fetchGeo () {
        this.log('Fetching GeoIP...');
        fetch("https://ipapi.co/json/")
            .then(res => res.json())
            .then(data => {
                if (data && data.country) {
                    const cacheData = {
                        country: data.country,
                        timestamp: Date.now()
                    };
                    window.localStorage.setItem(this.geoIpCacheKey, JSON.stringify(cacheData));
                    this.countryCode = data.country || 'US';
                    this.log('GeoIP fetched and cached:', cacheData);
                }
            })
            .catch(error => {
                this.log('GeoIP fetch failed:', error);
            });
    }

    getCountry () {
        if (this.countryCode) {
            return this.countryCode;
        }
        const cache = window.localStorage.getItem(this.geoIpCacheKey);
        if (cache) {
            try {
                const parsedCache = JSON.parse(cache);
                const now = Date.now();
                if ((now - parsedCache.timestamp) > this.geoIpCacheTTL) {
                    this.fetchGeo();
                }
                this.countryCode = parsedCache.country || 'US';
            } catch (e) {
                this.log('Error parsing GeoIP cache, refetching.', e);
                this.fetchGeo();
            }
        } else {
            this.log('No cached GeoIP found, fetching...');
            this.fetchGeo();
        }
        return this.countryCode;
    }
}

window.GEOIPHTMLElement = GEOIPHTMLElement;